import {calculateRoundedDayMetrics, getMetrics} from "@client/calculations";
import {Macros, PieChart} from "@client/components/PieChart";
import {dayFormStyles as styles} from "@client/components/styles";
import * as forms from "@client/forms";
import {server} from "@reactivated";
import * as React from "react";

interface Props {
    useKilojoules: boolean;
    day: server.journal.nutrition.Day.output;
    target: server.journal.nutrition.Target.output | null;
    targets: server.journal.nutrition.Target.output[];
    profile: server.core.rpc.Profile.output;
}

export const ReadOnlyDaySummary = (props: Props) => {
    const {total, remaining, target} = calculateRoundedDayMetrics(
        props.day,
        props.target,
        props.useKilojoules,
    );

    return (
        <forms.FormShell>
            {props.profile.has_hidden_macros == false && (
                <>
                    <div className={styles.row}>
                        <div className={styles.firstHeader} />
                        <div className={styles.header}>Total</div>
                        <div className={styles.header}>Target</div>
                        <div className={styles.header}>Remaining</div>
                    </div>
                    {getMetrics({useKilojoules: props.useKilojoules}).CORE_METRICS.map(
                        ([metric, , , unit, label]) => (
                            <div key={metric} className={styles.row}>
                                <div className={styles.label}>{label}</div>
                                <div className={styles.total}>
                                    {`${total[metric] ?? "0"} ${unit}`}
                                </div>
                                <div className={styles.target}>
                                    {target[metric] ?? "-"}
                                </div>
                                <div className={styles.remaining}>
                                    {remaining[metric] ?? "-"}
                                </div>
                            </div>
                        ),
                    )}
                    <div className={styles.optionalSection}>
                        {getMetrics({
                            useKilojoules: props.useKilojoules,
                        }).OPTIONAL_METRICS.map(([metric, , , unit, label]) => (
                            <div key={metric} className={styles.optionalRow}>
                                <div className={styles.optionalLabel}>{label}</div>
                                <div className={styles.optionalMacro}>
                                    {total[metric] != null
                                        ? `${total[metric]} ${unit}`
                                        : "-"}
                                </div>
                                <div className={styles.optionalMacro}>
                                    {target[metric] ?? "-"}
                                </div>
                                <div className={styles.optionalMacro}>
                                    {remaining[metric] ?? "-"}
                                </div>
                            </div>
                        ))}
                    </div>
                    <Macros>
                        <PieChart {...total.summary} />
                    </Macros>
                </>
            )}
            {props.target != null && (
                <forms.Label label="Target" error={null}>
                    <div className="text-gray-900">{props.target.name}</div>
                </forms.Label>
            )}
            {props.day.notes != null && (
                <forms.Label label="Notes" error={null}>
                    <div className="whitespace-pre-wrap text-gray-900">
                        {props.day.notes}
                    </div>
                </forms.Label>
            )}
        </forms.FormShell>
    );
};
